import {inject, Injectable} from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {Observable} from 'rxjs';
import {UrlService} from '@shared/services/url.service';
import {ClientDetailsDTO} from '@dto/entities/client-details-dto.model';
import {API_ENTITY} from '../../config/urls';

@Injectable({
  providedIn: 'root'
})
export class ClientDetailsService {
  private readonly http = inject(HttpClient);
  private readonly urlService = inject(UrlService);

  getClientDetails(clientCode: string): Observable<ClientDetailsDTO> {
    const endpointUrl = this.urlService.buildUrl(API_ENTITY, clientCode);
    return this.http.get<ClientDetailsDTO>(endpointUrl);
  }
}
